import { Card } from '@dma/ui';
import type { IndustrialProjectInfo } from '../content/industrial-projects.content';
import './IndustrialProjects.css';

export interface IndustrialProjectsProps {
  projects: IndustrialProjectInfo[];
}

/**
 * Rendered as its own section on ProjectsPage, visually and structurally
 * separate from the `dma-projects-page__grid` of mining ProjectCards — per
 * explicit client instruction not to mix the smelting-plant license in with
 * the calcite mine / exploration areas.
 */
export function IndustrialProjects({ projects }: IndustrialProjectsProps) {
  if (projects.length === 0) {
    return null;
  }
  return (
    <section className="dma-industrial-projects" aria-labelledby="dma-industrial-projects-heading">
      <h2 id="dma-industrial-projects-heading">پروژه‌ها و مجوزهای صنعتی</h2>
      <div className="dma-industrial-projects__grid">
        {projects.map((project) => (
          <Card key={project.title} className="dma-industrial-projects__item">
            <span className="dma-industrial-projects__type">{project.type}</span>
            <h3 className="dma-industrial-projects__title">{project.title}</h3>
            <p className="dma-industrial-projects__location">{project.location}</p>
            <p className="dma-industrial-projects__description">{project.description}</p>
          </Card>
        ))}
      </div>
    </section>
  );
}
